import React, { Fragment, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookie from 'js-cookie';
import authDuck from '../reducers/authDuck';
import Loading from '../components/common/Loading';
import { federatedRol } from '../utils/helpers';

const { signOut, hydrateAuth, getConfiguration } = authDuck.creators;

const PrivateRoute = ({ children }) => {
  const isAuthenticated = Cookie.get('POWERIMAC_ROL');
  const location = useLocation();
  const dispatch = useDispatch();
  const { rolActual, rol } = useSelector((state) => state.auth);
  const userForRoute = federatedRol.find(
    (o) => o.rol === rolActual && o.path.includes(location.pathname)
  );

  useEffect(() => {
    if (isAuthenticated) {
      if (!rolActual) {
        dispatch(hydrateAuth());
      } else {
        dispatch(getConfiguration());
      }
    } else {
      const cognitoSign = Object.keys(window.localStorage).some((key) =>
        key.startsWith('CognitoIdentityServiceProvider')
      );
      if (cognitoSign) {
        dispatch(signOut());
      }
    }
  }, [isAuthenticated, dispatch, rolActual, rol]);

  if (isAuthenticated && children) {
    if (userForRoute) {
      return <Fragment>
        {rolActual ? children : (
          <Loading/>
        )}
      </Fragment>;
    } else {
      return <Fragment>
        {rolActual ? <Redirect to="/404"/> : (
          <Loading/>
        )}
      </Fragment>;
    }
  } else {
    return <Redirect to={{ pathname: '/login', state: { from: location } }}/>;
  }
};

export default PrivateRoute;
